// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cart: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m18.587 7.877-1.301 4.628a.769.769 0 0 1-.741.56h-7.64l.22 1.157h7.426a.578.578 0 1 1 0 1.157H8.627a.576.576 0 0 1-.55-.472L6.627 7.284H5.37a.578.578 0 1 1 0-1.157h1.733c.277 0 .516.198.57.47l.035.3h10.138c.49 0 .879.487.74.98m-2.615 10.586a1.157 1.157 0 1 1 0-2.313 1.157 1.157 0 0 1 0 2.313m-6.941 0a1.156 1.156 0 1 1 .005-2.312 1.156 1.156 0 0 1-.005 2.312M12 0C5.371 0 0 5.371 0 12c0 6.626 5.371 12 12 12 6.626 0 12-5.374 12-12 0-6.629-5.374-12-12-12"
            />
        </svg>
    );
};

export default React.memo(Cart);
